import React from 'react'

import WarningImage from 'assets/svg/warning.svg'

import Button from 'components/Button'

import { Actions, Desc, Label, Info, Warning } from './CartMenu.style'

const CartRemove = ({ remove = () => {}, closeModal = () => {} }) => {
    return (
        <>
            <Warning>
                <img
                    className="alelo_warning"
                    src={WarningImage}
                    alt="Alelo Warning"
                />
                <Desc>
                    <Label>Excluir item da cesta</Label>
                    <Info>
                        Tem certeza que quer remover o benefício da sua cesta de
                        compras?
                    </Info>
                </Desc>
            </Warning>
            <Actions>
                <Button
                    id="cartDeleteProduct"
                    type="button"
                    kind="basic width-90"
                    onClick={remove}
                >
                    Excluir benefício
                </Button>
                <Button
                    id="cartKeepProduct"
                    type="button"
                    kind="link width-80"
                    onClick={closeModal}
                >
                    Manter benefício
                </Button>
            </Actions>
        </>
    )
}

export default CartRemove
